import { render, staticRenderFns } from "./LavApprovalStatus.vue?vue&type=template&id=3d2401aa"
import script from "./LavApprovalStatus.vue?vue&type=script&lang=js"
export * from "./LavApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports